import { Injectable, EventEmitter, OnInit } from "@angular/core";
// import { Observable } from 'rxjs/Rx';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
	NavigationStart
} from "@angular/router";

// Services
import * as srv from "../share/services";

@Injectable()
export class ActivateApplicationsHome implements CanActivate {
	name = "ActivateApplicationsHome";
	constructor(
		private _userSrv: srv.UserService,
		private _helperSrv: srv.HelperService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean> | boolean {
		"starting".logWithObject(this.name, this._userSrv.Data);
		//if (this._userSrv.getContact() === undefined) {
		if (!this._userSrv.CURRENTUSER_CONTACTID) {
			this._helperSrv.goToLogin();
			return false;
		} else {
			"returning".logWithObject(this.name, true);
			return true;
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/activates/applications.home.activate.ts